import { Attachment } from '@shared/interfaces/attachment.interface';
import { RemoteFile } from '@shared/interfaces/remote-file.interface';
import { Observable, Observer } from 'rxjs';
import { map } from 'rxjs/operators';

export class FileHelper {
  public static downloadFile(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    FileHelper.downloadFileByUrl(url, fileName);
    window.URL.revokeObjectURL(url);
  }

  public static downloadFileByUrl(url: string, fileName: string): void {
    const downloadLink = document.createElement('a');
    downloadLink.target = '_blank';
    downloadLink.href = url;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    document.body.removeChild(downloadLink);
  }

  public static downloadFiles(files: RemoteFile[]): void {
    const downloadLink = document.createElement('a');
    downloadLink.target = '_blank';
    document.body.appendChild(downloadLink);

    files.forEach((file) => {
      downloadLink.href = file.url;
      downloadLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    });

    document.body.removeChild(downloadLink);
  }

  public static downloadAttachment(attachment: Attachment): void {
    FileHelper.downloadFileByUrl(attachment.url, attachment.name);
  }

  public static readFileAsDataURL$(file: File): Observable<string> {
    return FileHelper.readFile$<string>((fileReader: FileReader) => fileReader.readAsDataURL(file));
  }

  public static readFileAsBase64$(file: File): Observable<string> {
    return FileHelper.readFileAsDataURL$(file).pipe(map((dataUrl) => dataUrl.replace(/^data:(.*,)?/, '')));
  }

  private static readFile$<T extends string | ArrayBuffer>(readAs: (fileReader: FileReader) => void): Observable<T> {
    return new Observable((observer: Observer<T>): void => {
      const fileReader: FileReader = new FileReader();
      fileReader.onload = (): void => {
        observer.next(fileReader.result as T);
        observer.complete();
      };
      fileReader.onerror = (): void => {
        observer.error(fileReader.error);
        observer.complete();
      };
      fileReader.onabort = (): void => observer.complete();
      readAs(fileReader);
    });
  }
}
